// INSERT YOUR JS HERE
import 'leaflet/dist/leaflet.css';
// Positioning and animation for clustered markers. The Default stylesheet is left out
// on purpose — the cluster icon is styled in main.scss to match the site.
import 'leaflet.markercluster/dist/MarkerCluster.css';
import autocomplete from "autocompleter";
import { Modal, Dropdown } from 'bootstrap';
import Search from './Search';
import React from 'react';
import { createRoot } from 'react-dom/client';
import PageList from './components/PageList';
import './components/EventMap';
import './components/AnalyticsChart';

// FontAwesomeConfig = { autoReplaceSvg: false };

window.autocomplete = autocomplete;
// Expose Dropdown so inline page scripts can init menus with a custom Popper config.
window.Dropdown = Dropdown;

window.escapeHtml = function (str) {
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

window.allowHtml = function (str) {
  return String(str).replace(/&lt;b&gt;/g, '<b>').replace(/&lt;\/b&gt;/g, '</b>').replace(/&lt;i&gt;/g, '<i>').replace(/&lt;\/i&gt;/g, '</i>').replace(/&lt;a href=&quot;http/g, '<a href="http').replace(/&lt;a href=&quot;tel:/g, '<a href="tel:').replace(/&lt;a href=&quot;mailto:/g, '<a href="mailto:').replace(/&quot;&gt;/g, "\">").replace(/&lt;\/a&gt;/g, "</a>").replace(/&nbsp;/g, ' ');
}

window.getParsedData = function (data, escapeHtml) {
  let parsedData;
  try {
    parsedData = JSON.parse(data);
    parsedData.blocks = parsedData.blocks && parsedData.blocks.map(block => {
      if (block.data && block.data.text) {
        let result;

        if (escapeHtml) {
          result = window.escapeHtml(block.data.text);
        } else {
          result = block.data.text;
        }
        block.data.text = window.allowHtml(result);

      }
      return block;
    })
  } catch (error) {
    console.error(error);
    parsedData = {}
  }
  return parsedData;
}

window.clearValidationError = function (inputElement) {
  // remove any lingering error
  const previousError = inputElement.parentElement.querySelector(".invalid-feedback");
  if (previousError) {
    previousError.remove();
  }
}

window.addValidationError = function (inputElement, error) {
  clearValidationError(inputElement);
  inputElement.classList.add('is-invalid');
  // add <span class="invalid-feedback">​error</span>
  const span = document.createElement("span");
  span.classList.add("invalid-feedback");
  span.append(error);
  inputElement.parentElement.append(span);
}

window.requireField = function (name) {
  const field = document.getElementById(name);
  clearValidationError(field);
  if (!field.value || field.value.length == 0) {
    addValidationError(field, "must not be blank");
    return Promise.reject("must not be blank");
  } else {
    return Promise.resolve(field.value);
  }
}

window.requireFields = function (...args) {
  return Promise.all(args.map(arg => requireField(arg)));
}

document.addEventListener("DOMContentLoaded", function (event) {
  const searchDocument = document.getElementById('search');

  if (!searchDocument) {
    return;
  }

  const searchRoot = createRoot(searchDocument);

  searchRoot.render(<Search />);
});

// Function to create PageList instance
const createPageList = function (containerId, pageIds, showList, params) {
  const container = document.getElementById(containerId);
  if (container) {
    const root = createRoot(container);
    root.render(<PageList pageIds={pageIds} showList={showList} params={params} />);
  }
};

const showPopup = function (title, description, action, type, actionText, inputName, inputValue) {
  const form = document.querySelector("#modal form");
  const header = document.querySelector("#modal .modal-title");
  const body = document.querySelector("#modal .modal-body");
  const button = document.querySelector("#modal .modal-footer #action");
  const descriptionElement = document.createElement("div");
  let inputElement;
  body.innerHTML = "";

  if (inputName) {
    inputElement = document.createElement("input");
    inputElement.name = inputName;
    inputElement.value = inputValue;
    inputElement.autocomplete = 'off';
    body.appendChild(inputElement);
  } else {
    descriptionElement.textContent = description;
  }

  body.appendChild(descriptionElement);

  header.textContent = title;
  button.textContent = actionText;

  form.action = action;
  form.method = type;
}

const openMoveSubCategoryModal = function (title, name, subCategoryId, action) {
  const form = document.querySelector("#modal form");
  const header = document.querySelector("#modal .modal-title");
  const body = document.querySelector("#modal .modal-body");
  const button = document.querySelector("#modal .modal-footer #action");
  body.innerHTML = "";

  // collect all subcategory buttons from the page
  const categoryLinks = document.querySelectorAll(".btn-category");

  // build a list inside the modal
  const list = document.createElement("div");
  list.classList.add("list-group");

  categoryLinks.forEach(link => {
    const id = link.getAttribute("data-category-id");

    // clone relevant child nodes (icon + text, but not badge)
    const item = document.createElement("button");
    item.type = "button";
    item.classList.add("list-group-item", "list-group-item-action", "btn", "btn-primary", "btn-category");

    // copy over the <i> and <span class="item">
    const icon = link.querySelector("i")?.cloneNode(true);
    const text = link.querySelector(".item")?.cloneNode(true);

    if (icon) item.appendChild(icon);
    if (text) item.appendChild(text);

    // click handler to set form action and submit
    item.addEventListener("click", () => {
      // inject hidden field with chosen subCategoryId
      const hiddenSubCategoryId = document.createElement("input");
      hiddenSubCategoryId.type = "hidden";
      hiddenSubCategoryId.name = "subCategoryId";
      form.appendChild(hiddenSubCategoryId);
      hiddenSubCategoryId.value = subCategoryId;

      const targetCategoryId = document.createElement("input");
      targetCategoryId.type = "hidden";
      targetCategoryId.name = "targetCategoryId";
      form.appendChild(targetCategoryId);
      targetCategoryId.value = id;

      form.action = action;
      form.method = "post"; // or whatever "type" you want
      form.submit();
    });

    list.appendChild(item);
  });

  body.appendChild(list);
  button.textContent = "Ok"

  header.textContent = title;
};

const openMoveServiceModal = function (title, name, serviceId, action) {
  const form = document.querySelector("#modal form");
  const header = document.querySelector("#modal .modal-title");
  const body = document.querySelector("#modal .modal-body");
  const button = document.querySelector("#modal .modal-footer #action");
  body.innerHTML = "";

  // collect all subcategory buttons from the page
  const categoryLinks = document.querySelectorAll(".btn-category");

  // build a list inside the modal
  const list = document.createElement("div");
  list.classList.add("list-group");

  categoryLinks.forEach(categoryLink => {
    const categoryId = categoryLink.getAttribute("data-category-id");

    // clone relevant child nodes (icon + text, but not badge)
    const categoryItem = document.createElement("button");
    categoryItem.type = "button";
    categoryItem.classList.add("list-group-item", "list-group-item-action", "btn", "btn-primary", "btn-category");

    // copy over the <i> and <span class="item">
    const icon = categoryLink.querySelector("i")?.cloneNode(true);
    const text = categoryLink.querySelector(".item")?.cloneNode(true);

    if (icon) categoryItem.appendChild(icon);
    if (text) categoryItem.appendChild(text);

    // click handler to set form action and submit
    categoryItem.addEventListener("click", () => {
      // inject hidden field with chosen subCategoryId
      const hiddenServiceId = document.createElement("input");
      hiddenServiceId.type = "hidden";
      hiddenServiceId.name = "serviceId";
      form.appendChild(hiddenServiceId);
      hiddenServiceId.value = serviceId;

      const targetCategoryId = document.createElement("input");
      targetCategoryId.type = "hidden";
      targetCategoryId.name = "targetId";
      form.appendChild(targetCategoryId);
      targetCategoryId.value = categoryId;

      const targetType = document.createElement("input");
      targetType.type = "hidden";
      targetType.name = "targetType";
      form.appendChild(targetType);
      targetType.value = "CATEGORY";

      form.action = action;
      form.method = "post"; // or whatever "type" you want
      form.submit();
    });

    list.appendChild(categoryItem);

    console.log(categoryItem, categoryItem.parentElement, categoryLink);
    const subCategoryLinks = categoryLink.parentElement.querySelectorAll(".btn-sub-category");

    subCategoryLinks.forEach(subCategoryLink => {
      console.log(subCategoryLink, "hej");
      const subCategoryId = subCategoryLink.getAttribute("data-subcategory-id");

      // clone relevant child nodes (icon + text, but not badge)
      const subCategoryItem = document.createElement("button");
      subCategoryItem.type = "button";
      subCategoryItem.classList.add("list-group-item", "list-group-item-action", "btn", "btn-primary", "btn-sub-category");

      // copy over the <i> and <span class="item">
      const icon = subCategoryLink.querySelector("i")?.cloneNode(true);
      const text = subCategoryLink.querySelector(".item")?.cloneNode(true);

      if (icon) subCategoryItem.appendChild(icon);
      if (text) subCategoryItem.appendChild(text);

      // click handler to set form action and submit
      subCategoryItem.addEventListener("click", () => {
        // inject hidden field with chosen subCategoryId
        const hiddenServiceId = document.createElement("input");
        hiddenServiceId.type = "hidden";
        hiddenServiceId.name = "serviceId";
        form.appendChild(hiddenServiceId);
        hiddenServiceId.value = serviceId;

        const targetCategoryId = document.createElement("input");
        targetCategoryId.type = "hidden";
        targetCategoryId.name = "targetId";
        form.appendChild(targetCategoryId);
        targetCategoryId.value = subCategoryId;

        const targetType = document.createElement("input");
        targetType.type = "hidden";
        targetType.name = "targetType";
        form.appendChild(targetType);
        targetType.value = "SUBCATEGORY";

        form.action = action;
        form.method = "post"; // or whatever "type" you want
        form.submit();
      });

      console.log(subCategoryItem);
      list.appendChild(subCategoryItem);
    });


  });

  body.appendChild(list);
  button.textContent = "Ok"

  header.textContent = title;
};

const openDeleteModal = function (title, description, name, id, action) {
  showPopup(title, description, action, "post", "Ta bort");
}

const openEditModal = function (title, name, id, action) {
  showPopup(title, null, action, "post", "Uppdatera", "name", name);
}

const deleteLanguage = function (id, name, action) {
  openDeleteModal('Ta bort språk', 'Är du säker på att du vill ta bort språket -data-?'.replace('-data-', name), name, id, action);
}

const createLanguage = function (action) {
  showPopup('Lägg till språk', null, action, 'post', 'Lägg till', 'name', null);
}

function deleteCategory(id, name, action) {
  openDeleteModal('Ta bort kategori', 'Är du säker på att du vill ta bort kategorin -data-?'.replace('-data-', name), name, id, action);
}

function deleteSubCategory(id, name, action) {
  openDeleteModal('Ta bort underkategori', 'Är du säker på att du vill ta bort underkategorin -data-?'.replace('-data-', name), name, id, action);
}

function moveSubCategory(id, name, action) {
  openMoveSubCategoryModal('Flytta underkategori ' + name, name, id, action);
}

function moveService(id, name, action) {
  openMoveServiceModal('Flytta tjänst ' + name, name, id, action);
}

function deleteService(id, name, action) {
  openDeleteModal('Ta bort tjänst', 'Är du säker på att du vill ta bort tjänsten -data-?'.replace('-data-', name), name, id, action);
}

function editCategory(id, name, action) {
  openEditModal('Byt namn på kategori', name, id, action);
}

function editSubCategory(id, name, action) {
  openEditModal('Byt namn på underkategori', name, id, action);
}

function editService(id, name, action) {
  openEditModal('Byt namn på tjänst', name, id, action);
}

function createCategory(action) {
  showPopup('Skapa kategori', null, action, 'post', 'Lägg till', 'name', null);
}

function createSubCategory(categoryId, categoryName, action) {
  showPopup('Skapa underkategori', null, action, 'post', 'Lägg till', 'name', null);
}

function createService(categoryId, categoryName, subCategoryId, subCategoryName, action) {
  showPopup('Skapa tjänst', null, action, 'post', 'Lägg till', 'name', null);
}

let deleteUrl;
let deleteUserId;

function openUserDeleteModal(userId, userName, deleteUserUrl) {
  deleteUrl = deleteUserUrl;
  deleteUserId = userId;
  const message = 'Är du säker på att du vill ta bort användare ' + escapeHtml(userName) + ' med id ' + escapeHtml(userId) + '?';
  document.querySelector("#deleteModal .modal-body").textContent = message;
  const form = document.querySelector("#deleteModal .modal-footer form");
  form.action = deleteUrl;
  form.method = "post";
}

document.addEventListener("DOMContentLoaded", () => {
  var button = document.getElementById('help-collapse-button');

  if (button) {
    button.onclick = () => {
      var collapse = document.getElementById('collapse');
      if (collapse.classList.contains('show')) {
        collapse.classList.remove('show');
      } else {
        collapse.classList.add('show');
      }
    }
  }

  // Language
  const addLanguage = document.querySelector('#languages-page .create-language');
  const languageResults = document.querySelector('#language-results');

  if (languageResults) {
    const pageIds = JSON.parse(languageResults.getAttribute("data-page-ids"));
    createPageList('page-list-container', pageIds);
  }

  if (addLanguage) {
    const languageCreateUrl = addLanguage.getAttribute('data-create-language-url');
    console.log(languageCreateUrl);

    addLanguage.onclick = () => createLanguage(languageCreateUrl);

  }

  document.querySelectorAll('#languages-page .delete-language').forEach(button => {
    button.onclick = () => {
      const languageId = button.getAttribute('data-language-id');
      const languageName = button.getAttribute('data-language-name');
      const languageDeleteUrl = button.getAttribute('data-language-delete-url');
      deleteLanguage(languageId, languageName, languageDeleteUrl);
    }
  });

  // Locations
  const countyResults = document.querySelector('#county-results');

  if (countyResults) {
    const defaultSearchParams = {
      countyId: parseInt(countyResults.getAttribute("data-county-id"))
    }
    const pageIds = JSON.parse(countyResults.getAttribute("data-page-ids"));
    createPageList('page-list-container', pageIds, true, defaultSearchParams);
  }

  const remoteResults = document.querySelector('#remote-results');

  if (remoteResults) {
    const pageIds = JSON.parse(remoteResults.getAttribute("data-page-ids"));
    createPageList('page-list-container', pageIds, true, {});
  }


  const locationResults = document.querySelector('#location-results');

  if (locationResults) {
    const defaultSearchParams = {
      locationId: parseInt(locationResults.getAttribute("data-location-id"))
    }
    const pageIds = JSON.parse(locationResults.getAttribute("data-page-ids"));
    createPageList('page-list-container', pageIds, true, defaultSearchParams);
  }

  const municipalityResults = document.querySelector('#municipality-results');

  if (municipalityResults) {
    const defaultSearchParams = {
      municipalityId: parseInt(municipalityResults.getAttribute("data-municipality-id"))
    }
    const pageIds = JSON.parse(municipalityResults.getAttribute("data-page-ids"));
    createPageList('page-list-container', pageIds, true, defaultSearchParams);
  }

  // Services
  const categoryResults = document.querySelector('#category-results');

  if (categoryResults) {
    const pageIds = JSON.parse(categoryResults.getAttribute("data-page-ids"));
    createPageList('page-list-container', pageIds);
  }

  const subCategoryResults = document.querySelector('#subcategory-results');

  if (subCategoryResults) {
    const pageIds = JSON.parse(subCategoryResults.getAttribute("data-page-ids"));
    createPageList('page-list-container', pageIds);
  }

  const serviceResults = document.querySelector('#service-results');

  if (serviceResults) {
    const pageIds = JSON.parse(serviceResults.getAttribute("data-page-ids"));
    createPageList('page-list-container', pageIds);
  }

  // User
  const deleteUserButton = document.querySelectorAll('.delete-user');

  if (deleteUserButton) {
    deleteUserButton.forEach(button => {
      const userId = button.getAttribute("data-user-id");
      const userName = button.getAttribute("data-user-name");
      const url = button.getAttribute("data-url");
      button.onclick = () => { openUserDeleteModal(userId, userName, url) }
    });
  }

  // Page
  const pageResults = document.querySelector('#page-results');

  if (pageResults) {
    const pageIds = JSON.parse(pageResults.getAttribute("data-page-ids"));
    createPageList('page-map', pageIds, false);
  }

  const pageEdit = document.querySelector('#page-edit');

  if (pageEdit) {
    createEditPage('edit-page-container', pageEdit.getAttribute("data-page-id"));
  }

  // Service page
  const servicePage = document.querySelector('#services-page');

  if (servicePage) {
    // Category
    document.querySelectorAll('#services-page .edit-category').forEach(sb => {
      sb.onclick = () => {
        const categoryId = sb.getAttribute("data-category-id");
        const categoryName = sb.getAttribute("data-category-name");
        const url = sb.getAttribute("data-url");

        editCategory(categoryId, categoryName, url);
      }
    });

    document.querySelectorAll('#services-page .delete-category').forEach(sb => {
      sb.onclick = () => {
        const categoryId = sb.getAttribute("data-category-id");
        const categoryName = sb.getAttribute("data-category-name");
        const url = sb.getAttribute("data-url");

        deleteCategory(categoryId, categoryName, url);
      }
    });

    document.querySelectorAll('#services-page .create-category').forEach(sb => {
      const url = sb.getAttribute("data-url");
      sb.onclick = () => {
        createCategory(url);
      }
    });

    // SubCategory
    document.querySelectorAll('#services-page .edit-subcategory').forEach(sb => {
      sb.onclick = () => {
        const subCategoryId = sb.getAttribute("data-subcategory-id");
        const subCategoryName = sb.getAttribute("data-subcategory-name");
        const url = sb.getAttribute("data-url");

        editSubCategory(subCategoryId, subCategoryName, url);
      }
    });

    document.querySelectorAll('#services-page .delete-subcategory').forEach(sb => {
      sb.onclick = () => {
        const subCategoryId = sb.getAttribute("data-subcategory-id");
        const subCategoryName = sb.getAttribute("data-subcategory-name");
        const url = sb.getAttribute("data-url");

        deleteSubCategory(subCategoryId, subCategoryName, url);
      }
    });

    document.querySelectorAll('#services-page .create-subcategory').forEach(sb => {
      const url = sb.getAttribute("data-url");
      const categoryId = sb.getAttribute("data-category-id");
      const categoryName = sb.getAttribute("data-category-name");

      sb.onclick = () => {
        createSubCategory(categoryId, categoryName, url);
      }
    });

    document.querySelectorAll('#services-page .move-subcategory').forEach(sb => {
      const url = sb.getAttribute("data-url");
      const categoryId = sb.getAttribute("data-subcategory-id");
      const categoryName = sb.getAttribute("data-subcategory-name");

      sb.onclick = () => {
        moveSubCategory(categoryId, categoryName, url);
      }
    });

    document.querySelectorAll('#services-page .move-service').forEach(sb => {
      const url = sb.getAttribute("data-url");
      const serviceId = sb.getAttribute("data-service-id");
      const serviceName = sb.getAttribute("data-service-name");

      sb.onclick = () => {
        moveService(serviceId, serviceName, url);
      }
    });

    // Service
    document.querySelectorAll('#services-page .edit-service').forEach(sb => {
      sb.onclick = () => {
        const serviceId = sb.getAttribute("data-service-id");
        const serviceName = sb.getAttribute("data-service-name");
        const url = sb.getAttribute("data-url");

        editService(serviceId, serviceName, url);
      }
    });

    document.querySelectorAll('#services-page .delete-service').forEach(sb => {
      sb.onclick = () => {
        const serviceId = sb.getAttribute("data-service-id");
        const serviceName = sb.getAttribute("data-service-name");
        const url = sb.getAttribute("data-url");

        deleteService(serviceId, serviceName, url);
      }
    });

    document.querySelectorAll('#services-page .create-service').forEach(sb => {
      const url = sb.getAttribute("data-url");

      const categoryId = sb.getAttribute("data-category-id");
      const categoryName = sb.getAttribute("data-category-name");
      const subCategoryId = sb.getAttribute("data-subcategory-id");
      const subCategoryName = sb.getAttribute("data-subcategory-name");
      sb.onclick = () => {
        createService(categoryId, categoryName, subCategoryId, subCategoryName, url);
      }
    });
  }

}, false);

// Accordion behavior for service-tree: only one category open at a time
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.service-tree').forEach(tree => {
    // Skip editor trees (React manages its own state)
    if (tree.classList.contains('service-tree--editor')) return;

    const categories = tree.querySelectorAll(':scope > .service-tree__category');
    categories.forEach(details => {
      details.addEventListener('toggle', () => {
        if (details.open) {
          categories.forEach(other => {
            if (other !== details) other.removeAttribute('open');
          });
        }
      });
    });

    // Same for subcategories within each category
    tree.querySelectorAll('.service-tree__category-body').forEach(body => {
      const subs = body.querySelectorAll(':scope > .service-tree__subcategory');
      subs.forEach(details => {
        details.addEventListener('toggle', () => {
          if (details.open) {
            subs.forEach(other => {
              if (other !== details) other.removeAttribute('open');
            });
          }
        });
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const consentBanner = document.getElementById("cookie-consent");
  const acceptBtn = document.getElementById("accept-cookies");

  // Kolla om användaren redan accepterat
  if (!localStorage.getItem("cookieConsent")) {
    consentBanner.style.display = "flex";
  }

  // Klick på "Acceptera"
  acceptBtn.addEventListener("click", function () {
    localStorage.setItem("cookieConsent", "true");
    consentBanner.style.display = "none";
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const typePrivate = document.getElementById('typePrivate');
  const typeCompany = document.getElementById('typeCompany');
  const invoiceFields = document.getElementById('invoice-fields');
  const priceAmount = document.getElementById('price-amount');
  const vatInfoList = document.getElementsByClassName('vat-info');
  const membershipFeeContainer = document.getElementById('membership-fee-container');
  const membershipFee = document.getElementById('membership-fee');

  if (!priceAmount) return;

  const basePrice = parseFloat(priceAmount.getAttribute('data-price')) || 0;
  const membershipPrice = parseFloat(membershipFee.getAttribute('data-membership-price')) || 0;
  const memberPriceStr = priceAmount.getAttribute('data-price-member');
  const memberPrice = memberPriceStr ? parseFloat(memberPriceStr) : basePrice;

  // Membership radios
  const memberRadios = document.querySelectorAll('input[name="membershipStatus"]');

  function updateState() {
    // Default values
    let isCompany = false;
    if (typeCompany) isCompany = typeCompany.checked;

    let membershipStatus = 'nonMember'; // Default
    const checkedMemberRadio = document.querySelector('input[name="membershipStatus"]:checked');
    if (checkedMemberRadio) {
      membershipStatus = checkedMemberRadio.value;
    }



    // Determine Base Event Price
    let currentEventPrice = basePrice;
    if (membershipStatus === 'member') {
      currentEventPrice = memberPrice;
    } else if (membershipStatus === 'becomeMember') {
      currentEventPrice = memberPrice;
    } else if (membershipStatus === 'nonMember') {
      currentEventPrice = basePrice;
    }

    // Invoice fields are now always visible (mandatory for all registrations)

    // Toggle Membership Fee Display
    if (membershipFeeContainer) {
      if (membershipStatus === 'becomeMember') {
        membershipFeeContainer.style.display = 'block';
      } else {
        membershipFeeContainer.style.display = 'none';
      }
    }

    // Calculate Final Price with VAT
    // VAT Logic: 
    // Private: Inc VAT (1.25x)
    // Company: Ex VAT (1.0x)

    let displayPrice = currentEventPrice;
    if (!isCompany) {
      displayPrice = Math.round(currentEventPrice / 100) * 100 * 1.25;
    }

    // Update UI
    if (priceAmount) {
      // Round to 2 decimals if needed, or integer if that's the style. 
      // User saw "2500" and "3125" (2500*1.25), so ints or decimals.
      // Let's use clean string if integer, or 2 decimals if not.
      priceAmount.textContent = Number.isInteger(displayPrice) ? displayPrice : displayPrice.toFixed(2);
    }

    console.log(membershipPrice, membershipFee);
    // Determine membership price
    let newMembershipPrice = membershipPrice;
    if (!isCompany) {
      newMembershipPrice = Math.round(newMembershipPrice / 10) * 10 * 1.25;
    }
    membershipFee.textContent = Number.isInteger(newMembershipPrice) ? newMembershipPrice : newMembershipPrice.toFixed(2);


    if (vatInfoList.length > 0) {
      for (let i = 0; i < vatInfoList.length; i++) {
        vatInfoList.item(i).textContent = isCompany ? "(exkl. moms)" : "(inkl. moms)";
      }
    }
  }

  if (typePrivate && typeCompany) {
    typePrivate.addEventListener('change', updateState);
    typeCompany.addEventListener('change', updateState);
  }

  if (memberRadios.length > 0) {
    memberRadios.forEach(radio => radio.addEventListener('change', updateState));
  }

  // Show membership modal when selecting member or becomeMember
  const memberRadio = document.getElementById('member');
  const becomeMemberRadio = document.getElementById('becomeMember');
  const membershipInfoModalEl = document.getElementById('membershipInfoModal');
  if (membershipInfoModalEl) {
    const showMembershipModal = function() {
      if (this.checked) {
        const modal = Modal.getOrCreateInstance(membershipInfoModalEl);
        modal.show();
      }
    };
    if (memberRadio) {
      memberRadio.addEventListener('change', showMembershipModal);
    }
    if (becomeMemberRadio) {
      becomeMemberRadio.addEventListener('change', showMembershipModal);
    }
  }

  // Show group discount info when company is selected
  const companyRadio = document.getElementById('typeCompany');
  const groupDiscountInfo = document.getElementById('group-discount-info');
  if (companyRadio && groupDiscountInfo) {
    const typeRadios = document.querySelectorAll('input[name="customerType"]');
    typeRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        groupDiscountInfo.style.display = this.value === 'company' ? 'block' : 'none';
      });
    });
    // Show on load if company selected
    if (companyRadio.checked) {
      groupDiscountInfo.style.display = 'block';
    }
  }

  // Initial call
  updateState();
});